import { Box, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useColors from "../../../api/hooks/useColors";
import TextButton from "../../../components/buttons/TextButton";
import SvgToIcon from "../../../icons/SvgToIcon";
import { icons, severities } from "../../stack/environment/icons/iconExport";
import { IntegrationCategory } from "../../stack/integrations/IntegrationsMapping";

export default function NoIntegrationsAlertBar() {
  const colors = useColors();
  const navigate = useNavigate();
  return (
    <Grid item>
      <Box
        display="flex"
        alignItems="center"
        width
        sx={{
          padding: "12px 12px 12px 4px",
          backgroundColor: colors.alert_info_bg,
          borderRadius: "8px",
          border: `0.5px solid ${colors.alert_info_stroke}`,
          marginBottom: "24px",
        }}
      >
        <Box display="flex" alignItems="center" gap="16px">
          <Box display="flex" alignItems="center">
            <Box
              display="flex"
              alignItems="flex-start"
              alignSelf="stretch"
              padding="0 16px 0 8px"
            >
              <SvgToIcon
                IconLogo={severities.SeverityBackgroundInfoIcon}
                width="24px"
                height="24px"
                style={{ color: colors.info_main }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              padding="2px 2px 0 0 "
              alignItems="flex-start"
              gap="6px"
            >
              <Typography
                variant="subtitle2"
                color={colors.text_primary}
                whiteSpace="nowrap"
              >
                Set up your preferred integration to start receiving
                organization notifications
              </Typography>
            </Box>
            <Box
              display="flex"
              height="24px"
              padding="0 8px"
              justifyContent="center"
              alignItems="center"
            >
              <TextButton
                color="primary"
                size="xs"
                onClick={() => {
                  navigate(
                    `/inventory/integrations?integrationType=${IntegrationCategory.ALERTING}`
                  );
                }}
                endIcon={icons.arrowRightIcon}
                sx={{ padding: "0 8px" }}
              >
                Manage Integrations
              </TextButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </Grid>
  );
}
